import { render, staticRenderFns } from "./StoreUser.vue?vue&type=template&id=2c7cf2f0&scoped=true"
import script from "./StoreUser.vue?vue&type=script&lang=js"
export * from "./StoreUser.vue?vue&type=script&lang=js"
import style0 from "./StoreUser.vue?vue&type=style&index=0&id=2c7cf2f0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7cf2f0",
  null
  
)

export default component.exports